module.exports = __webpack_public_path__ + "img/tag.36d737e.png";